import React from 'react'
import Footer from '../Footer/Footer'
import Navbar from "../Navbar/Navbar"
import Home from './Home'

const MainHome = () => {
  return (
    <div>
    <Navbar/>
    <Home/>
    <Footer/>
    </div>
  )
}

export default MainHome